import Button from '@bolt/react-button';

function FormIcons({ icons, ...otherProps }) {
  return (
    <bolt-input-icons {...otherProps}>
      <ul className="o-bolt-inline-list o-bolt-inline-list--xsmall">
        {icons &&
          icons.map((icon, i) => {
            if (icon.content) {
              return (
                <li className="o-bolt-inline-list__item" key={i}>
                  {icon.isSubmit ? (
                    <Button
                      className="c-bolt-input-icon c-bolt-input-icon--link"
                      type="submit"
                      hierarchy="transparent"
                      aria-label={icon.ariaLabel}
                      onClick={icon.onClickHandler}
                      isLoading={icon.isLoading}>
                      {icon.content}
                    </Button>
                  ) : (
                    <div className="c-bolt-input-icon">{icon.content}</div>
                  )}
                </li>
              );
            }
          })}
      </ul>
    </bolt-input-icons>
  );
}

export default FormIcons;
